
import { createSlice } from "@reduxjs/toolkit";

const locationSlice = createSlice({
  name: "location",
  initialState: {
    locationData: null, // store everything here
  },
  reducers: {
    setUserLocation(state, action) {
      state.locationData = action.payload; // full address + lat/lng
    },
  },
});

export const { setUserLocation } = locationSlice.actions;
export default locationSlice.reducer;
